module.exports = "pegasus/assets/blocks/column-2-theme2.png";